import { render, staticRenderFns } from "./SoundControllerTemplate.vue?vue&type=template&id=33aa9be9&scoped=true&"
import script from "./SoundControllerTemplate.vue?vue&type=script&lang=js&"
export * from "./SoundControllerTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SoundControllerTemplate.vue?vue&type=style&index=0&id=33aa9be9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aa9be9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
